<template>
  <div>
    <a :href="Lang.locale === defaultLanguage ? '/cart/' + cart.orderId: '/' + Lang.locale + '/cart/'+ cart.orderId">
      <div class="cart-count">{{cart.getServicesInCart()}}</div>
<!--      <div class="sum">{{cart.getTotalServicesPrice()}} грн.</div>-->
<!--      <div class="cart-text">{{Lang.get('js.cart_order')}}</div>-->
    </a>
  </div>
</template>

<script>
  export default {
      name: 'btn-cart',
      data() {
          return {
              cart: window.cart,
              Lang,
              defaultLanguage
          }
      },
  }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/order/BtnCart.vue